module.exports = __webpack_public_path__ + "img/thumbnail-collections-calyrafit.32d4f80e.webp";